import { render, staticRenderFns } from "./bottomBar.vue?vue&type=template&id=5b139431&scoped=true&"
var script = {}
import style0 from "./bottomBar.vue?vue&type=style&index=0&id=5b139431&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b139431",
  null
  
)

export default component.exports